import React from 'react';
import moment from 'moment';
import { toast } from 'react-toastify';
import { clearStorageData } from './upLoadHelper';
import 'react-toastify/dist/ReactToastify.css';
import { isMobile } from 'react-device-detect';
import { repeatStartHours, repeatEndHours } from '../common/constants';
import { convertTime } from './time';

export const convertLocalTime = (timestamp) => {
  return moment.utc(timestamp).local().format('YYYY-MM-DD HH:mm:ss');
};

export const serviceRequestTableLocalTime = (timestamp, from) => {
  switch (from) {
    case 'contacts':
      return convertTime(timestamp, 'long');
    case 'suitepage':
      return convertTime(timestamp, 'MM-DD-YYYY');
    default:
      return convertTime(timestamp, 'date');
  }
};

export const checkUserPermission = (page, type, brandedId) => {
  let data = localStorage.getItem('permissions');
  if (brandedId === 'serviceRequests') page = 'Service Requests';
  if (data) {
    let settings = JSON.parse(data);
    if (settings.hasOwnProperty(page)) {
      if (type) {
        let value = settings[page].filter((pro) => pro === type)[0];
        return value ? true : false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  } else {
    clearStorageData();
  }
};

export const URLValidation = (string) => {
  return string.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
  );
};

export const checkSparkDataAvailable = (data, role) => {
  if (data && data.isSpark) {
    let roleCheck = role !== 'Super Admin' && role !== 'Admin';
    return data && data.isSpark === true && roleCheck;
  } else {
    return false;
  }
};

export const sparkDateValidation = (date) => {
  return date && date !== '0001-01-01T00:00:00+00:00';
};

export const convertHTMLToString = (html) => {
  return html ? html.replace(/<[^>]+>/g, '').trim() : '';
};

export const getURLExtension = (url) => {
  if (url) {
    let ext = url.split(/[#?]/)[0].split('.').pop().trim();
    return ext.toLowerCase();
  } else {
    return '';
  }
};

export const getFileTypeIcon = (fileExtension) => {
  if (fileExtension === 'pdf') {
    return 'pdficon.png';
  } else {
    return 'imageicon.png';
  }
};

export const getTenantName = () => {
  return localStorage.getItem('theme');
};

// check the logged user can access the module
export const onCheckUserCanAccessTheModule = (roles) => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user && user.id) {
    const roleName = user.roles[0].role.name;
    const canAccess = roles.includes(roleName);
    return canAccess;
  }
};

export const ToastSuccess = (message) => {
  toast.success(message, { autoClose: 3000, position: 'top-center' });
};

export const ToastFail = (message) => {
  toast.error(message, { autoClose: 3000, position: 'top-center' });
};

export const ToastInfo = (message) => {
  toast.info(message, { autoClose: 3000, position: 'top-center' });
};

export const onRequestPhoneCall = (phoneNumber) => {
  if (isMobile) {
    return <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>;
  } else {
    return phoneNumber;
  }
};

// function to get the hours based on the starthour and endhour
export const fetchRepeatHours = () => {
  let repeatHours = [];
  for (let index = repeatStartHours; index <= repeatEndHours; index++) {
    repeatHours = [...repeatHours, index];
  }
  return repeatHours;
};

export const convertToDisplayText = (text, value) => {
  let result = '';
  switch (text) {
    case 'Day':
      result = value ? (value == 1 ? 'day' : 'days') : 'day';
      break;
    case 'Week':
      result = value ? (value == 1 ? 'week' : 'weeks') : 'week';
      break;
    case 'Weekly':
      result = value ? (value == 1 ? 'week' : 'weeks') : 'week';
      break;
    case 'Month':
      result = value ? (value === 1 ? 'month' : 'months') : 'month';
      break;
    case 'Monthly':
      result = value ? (value === 1 ? 'month' : 'months') : 'month';
      break;
    case 'Year':
      result = value ? (value === 1 ? 'year' : 'years') : 'year';
      break;
    case 'Annually':
      result = value ? (value === 1 ? 'year' : 'years') : 'year';
      break;
    default:
      break;
  }
  return result;
};
